import affiliateAccessReducer from '../../../../common/store/reducers/access';

export { affiliateAccessReducer };
